/**
 * EmptyState - Placeholder shown before first query execution
 *
 * Displays centered message in right pane before user executes query.
 * Pattern from QueryWriter.tsx lines 265-279.
 */
export const EmptyState = () => {
  return (
    <div
      className="flex h-full w-full items-center justify-center p-6"
      data-testid="query-split-empty-state"
    >
      <div className="text-center">
        <p className="text-chariot-text-secondary text-sm">Ready to Execute</p>
        <p className="text-chariot-text-tertiary mt-2 text-xs">
          Execute query to see results
        </p>
      </div>
    </div>
  );
};
